/**
 * get unity
 * @param {string} unit
 * @param {number} qt
 */
export const getUnit = (unit, qt) => {
  switch (unit) {
    case 'grammes':
      return 'grammes';
    case 'part':
      return +qt > 1 ? 'parts' : 'part';
    case 'unité':
      return +qt > 1 ? 'unités' : 'unité';
    default:
      return unit;
  }
};
